<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box no-display">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Other Form Fees</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <br />
            <v-row justify="center" dense>
                <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
                    <v-radio label="PAY" value="pay" @change="receipt_dialog = false" color="#0f2027"></v-radio>
                    <v-radio label="Report" value="report" @change="pay_receipt_dialog = false"
                        color="#0f2027"></v-radio>
                </v-radio-group>
            </v-row>
            <v-row justify="center" dense>
                <v-col cols="12" sm="3" md="3" v-if="radios == 'report'">
                    <p><b>Academic Year</b></p>
                    <v-select rounded :items="aylist" label="*Academic Year" item-text="ay" item-value="id" outlined
                        dense v-model="ay"></v-select>
                </v-col>
                <v-col cols="12" sm="3" md="3" v-if="radios == 'pay'">
                    <v-select rounded :items="aylist" label="*Academic Year" item-text="ay" item-value="id" outlined
                        dense v-model="ay"></v-select>
                </v-col>
                <v-col cols="12" sm="3" md="3" v-if="radios == 'pay'">
                    <v-select rounded :items="std_list" label="Standard" item-text="standard" item-value="id" outlined
                        dense v-model="std"></v-select>
                </v-col>
                <v-col cols="12" sm="3" md="3" v-if="radios == 'report'">
                    <p><b>Standard</b></p>
                    <v-select rounded :items="std_list_all" label="Standard" item-text="standard" item-value="id"
                        outlined dense v-model="std_all"></v-select>
                </v-col>
                <v-col cols="12" sm="3" v-if="radios == 'report'">
                    <p><b>From Date</b>&nbsp;<small>(inclusive)</small></p>
                    <v-text-field outlined dense rounded type="date" v-model="fromdate"></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" v-if="radios == 'report'">
                    <p><b>To Date</b>&nbsp;<small>(exclusive)</small></p>
                    <v-text-field outlined dense rounded type="date" v-model="todate"></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3" v-if="radios == 'pay'">
                    <v-select rounded :items="mode_list" label="*Payment Mode" item-text="name" item-value="id" outlined
                        dense v-model="mode"></v-select>
                </v-col>
            </v-row>

            <v-row justify="center" dense v-if="radios == 'pay'">
                <v-col cols="12" sm="8" md="8">
                    <v-text-field outlined rounded dense hint="Enter name of student" persistent-hint label="*Name"
                        type="text" v-model="stud_name"></v-text-field>
                </v-col>
            </v-row>
            <v-row justify="center" dense v-if="radios == 'pay'">
                <v-col cols="12" sm="3" md="3">
                    <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition"
                        offset-y max-width="290px" min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field dense v-model="dob" name="Birth Date" hint="DD/MM/YYYY" persistent-hint
                                label="Birth Date" @blur="date = parseDate(dob)" v-on="on" rounded outlined
                                clearable></v-text-field>
                        </template>
                        <v-date-picker v-model="date" no-title @input="menu1 = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-text-field outlined rounded dense hint="Enter amount to be collected" persistent-hint
                        label="*Amount" type="number" v-model="amount"></v-text-field>
                </v-col>
            </v-row>
            <v-row justify="center" dense v-if="radios == 'pay'">
                <v-col cols="12" sm="8" md="8">
                    <v-text-field outlined rounded dense hint="Enter remark (if any)" persistent-hint label="Remark"
                        type="text" v-model="remark"></v-text-field>
                </v-col>
            </v-row>
            <v-row justify="center" align="center" dense v-if="radios == 'pay'">
                <v-col cols="12" sm="1" md="1"></v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-btn class="no-display" color="warning" :loading="pay_loader" @click="payOtherFees">Pay</v-btn>
                </v-col>
            </v-row>
            <v-row justify="center" align="center" dense v-if="radios == 'report'">
                <v-btn class="no-display" color="warning" :loading="pay_loader"
                    @click="fetchOtherFeesReport">Fetch</v-btn>
            </v-row>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <br />
            <!-- <div id="one_view_form" v-if="other_form_fees_data != null">
        <other-form-receipt
          :other_form_fees_data="other_form_fees_data"
        ></other-form-receipt>
      </div> -->
        </v-card>
        <div id="one_view_form" v-if="
        other_form_fees_data != null && radios == 'pay' && pay_receipt_dialog
      ">
            <other-form-receipt :other_form_fees_data="other_form_fees_data"
                :org_basic_data="org_basic_data"></other-form-receipt>
        </div>
        <v-card class="box no-display" v-if="radios == 'report' && report_data.length > 0">
            <!-- export button code -->
            <v-col cols="12" sm="3" md="3" v-if="report_data != null">
                <v-btn class="ma-2 no-display " rounded color="success" outlined
                    @click="fnExcelReport('my-table-id', 'OtherFeesReport')" :loading="loader"><v-icon
                        color="success">mdi-export</v-icon>Export</v-btn>
            </v-col>
            <!-- export button code end -->
            <div id="my-table-id">
                <v-data-table :headers="headers" :items="report_data">
                    <template v-slot:top>
                        <v-toolbar flat class="toolbar">
                            <v-toolbar-title>Other Fees Details</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.print="{ item }">
                        <v-tooltip top color="warning">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="mt-1 mb-1" outlined rounded small color="warning" v-bind="attrs" v-on="on"
                                    @click="print1(item)"> <v-icon color="warning">mdi-printer</v-icon>Print
                                    Receipt</v-btn>
                            </template>
                            <span> Print Fee Receipt!!! </span>
                        </v-tooltip>
                    </template>
                    <template v-slot:[`item.edit`]="{ item }">
                        <div>
                            <v-avatar size="25" class="edit-avatar">
                                <v-icon class="mr-2 edit-v-icon" color="success" @click="openEditDialog(item)" title="edit">edit</v-icon>
                            </v-avatar>
                        </div>
                    </template>
                    <template v-slot:[`item.standard`]="{ item }">
                        <div v-if="item.standard">
                           {{ item.standard }}
                        </div>
                        <div v-else>
                            Staff
                        </div>
                    </template>
                    <template v-slot:[`item.delete`]="{ item }">
                        <div>
                            <v-avatar size="35">
                                <v-icon class="mr-4 v-icon-size" color="red" @click="deleteDetails(item)"
                                    >mdi-trash-can</v-icon>
                            </v-avatar>
                        </div>
                    </template>
                </v-data-table>
            </div>
        </v-card>
        <!-- print receipt -->
        <v-card id="one_view_form" v-if="radios == 'report' && receipt_dialog">
            <other-form-receipt :other_form_fees_data="other_form_fees_data"
                :org_basic_data="org_basic_data"></other-form-receipt>
        </v-card>
        <v-dialog v-model="editDialog" persistent max-width="700px">
            <v-card>
                <v-toolbar dense flat class="toolbar">
                <v-toolbar-title >Edit Other Form Fee Details</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="editDialog = false">
                    <v-icon class="white--text">mdi-close</v-icon>
                </v-btn>
                </v-toolbar>

                <v-card-text class="pb-0">
                <v-container>
                    <v-row dense>
                    <v-col cols="12" sm="6">
                        <v-text-field label="Form No." readonly filled dense outlined v-model="editItem.form_no" />
                    </v-col>                   
                    <v-col cols="12" sm="6">
                        <v-text-field label="Standard" readonly filled dense outlined v-model="editItem.standard" />
                    </v-col>
                    <v-col cols="12">
                        <v-text-field label="Name" readonly filled dense outlined v-model="editItem.name" />
                    </v-col>
                    <!-- <v-col cols="12" sm="12">
                        <v-text-field label="DOB" readonly filled dense outlined v-model="editItem.dob" />
                    </v-col>                                       -->
                    <v-col cols="12" sm="6">
                        <v-menu v-model="editMenu" :close-on-content-click="false" transition="scale-transition" offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                            v-model="editItem.generation_date"
                            label="Date"
                            readonly
                            dense
                            outlined
                            v-bind="attrs"
                            v-on="on"
                            />
                        </template>
                        <v-date-picker v-model="editDateFormatted" @input="updateEditDate" />
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field label="Amount" type="number" dense outlined v-model="editItem.amount" />
                    </v-col> 
                    <v-col cols="12" sm="6">
                        <v-select
                        label="Payment Mode"
                        :items="mode_list"
                        item-text="name"
                        item-value="id"
                        dense
                        outlined
                        v-model="editItem.mode"
                        />
                    </v-col>
                    <v-col cols="12">
                        <v-text-field label="Remark" dense outlined v-model="editItem.remark" />
                    </v-col>
                    </v-row>
                </v-container>
                </v-card-text>

                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="button mr-6" @click="UpdateFeeDetails()">Save</v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
    </div>
</template>

<script>
    // import OFR from "./OtherFeesReceipt.vue";
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
    export default {
    components: {
            Breadcrumbs
            // "other-form-receipt": OFR,
        },
        data: () => ({
            fromdate: new Date(new Date().getFullYear(), new Date().getMonth() - 0, 2).toISOString().substr(0, 10),
            todate: new Date().toISOString().slice(0, 10),
            radios: null,
            overlay: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            pay_loader: false,
            //////////////
            aylist: [],
            std_list: [],
            mode_list: [],
            ay: null,
            std: null,
            mode: null,
            stud_name: null,
            dob: null,
            amount: 0,
            remark: "",
            editDialog: false,
            editItem: {
                id: null,
                form_no:"",
                name: "",
                standard:"",
                
                generation_date:"",
                amount: null,
                remark: "",
                mode: null,
            },
            editMenu: false,
            editDateFormatted: null,
            /////
            // extraBreadcrumbItems: [


            // ],
            // breadcrumbClass: "breadcrumb-style1",
            date: new Date().toISOString().substr(0, 10),
            menu1: false,
            ////
            other_form_fees_data: null,
            org_basic_data: null,
            report_data: [],
            std_list_all:[],
            std_all:null,
            headers: [
                { text: "Sr No", value: "srno" },
                { text: "Form No", value: "form_no" },
                { text: "Name", value: "name" },
                { text: "Standard", value: "standard" },
                
                { text: "Date", value: "generation_date" },
                { text: "Amount", value: "amount" },
                { text: "Mode", value: "mode" },
                { text: "Remark", value: "remark" },
                { text: "Print Receipt", value: "print" },
                { text: "Edit", value: "edit" },
                { text: "Delete", value: "delete" },
            ],
            table_fields: {
                "Sr. No": "srno",
                "Form No": "form_no",
                Name: "name",
                DOB: "dob",
                Date: "generation_date",
                Amount: "amount",
                Mode: "mode",
                Remark: "remark",
            },
            receipt_dialog: false,
            pay_receipt_dialog: false,
            //
        }),
        mounted() {
            this.onLoad();
        },
        watch: {
            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
            date(val) {
                this.dob = this.formatDate(this.date);
            },
        },

        methods: {
            openEditDialog(item) {
                this.editItem = { ...item };
                this.editDateFormatted = this.convertDisplayToDate(item.generation_date);
                this.editItem.generation_date = this.editDateFormatted;
                const foundMode = this.mode_list.find(m => m.name === item.mode || m.id === item.mode);
                this.editItem.mode = foundMode ? foundMode.id : null;
                // console.log('Opening dialog with mode:', item.mode, '-> resolved id:', this.editItem.mode);
                this.editDialog = true;
            },

            convertDisplayToDate(dateStr) {
                if (!dateStr) return null;
                const months = {
                Jan: '01', Feb: '02', Mar: '03', Apr: '04',
                May: '05', Jun: '06', Jul: '07', Aug: '08',
                Sep: '09', Oct: '10', Nov: '11', Dec: '12'
                };

                const [day, mon, year] = dateStr.split('/');
                const month = months[mon];
                return `${year}-${month}-${day.padStart(2, '0')}`;
            },
            updateEditDate(val) {
                this.editItem.generation_date = val;
                this.editDateFormatted = val;
            },
            UpdateFeeDetails(){
                const formData = {
                    id: this.editItem.id,
                    amount: this.editItem.amount,
                    remark: this.editItem.remark,
                    
                    name: this.editItem.name,
                    standard: this.editItem.standard, 
                    date: this.editItem.generation_date, 
                    mode: this.editItem.mode,                  
                };
                axios
                    .post("/MiscAndOtherFees/editOtherFormFees", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("green", "Form Fee Details Updated Successfully"); 
                            this.editDialog = false;  
                            this.fetchOtherFeesReport();                        
                        } else {
                            this.showSnackbar("red", "Something went wrong...");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.editDialog = false;
                    })
                    .catch((error) => {
                        this.onerror(error);
                    })
                    .finally(() => {
                    });
            },
            deleteDetails(item) {
            if (!confirm("Are You Sure You Want To Delete ...?")) return;
            const formData = {
                id: item.id,
            };
            axios
                .post("/MiscAndOtherFees/deleteOtherFormFees", formData)
                .then((res) => {
                    if (res.data.status == "YES") {
                        this.showSnackbar("#4caf50", "Other Form Fee Details Deleted Successfully..."); 
                        this.fetchOtherFeesReport();
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    }
                })
                ;
            },
            print1(item) {
                this.receipt_dialog = true;
                this.other_form_fees_data = item;
                localStorage.setItem("other_form_fees_data",JSON.stringify(this.other_form_fees_data));
                localStorage.setItem("receipt_dialog", JSON.stringify(this.receipt_dialog));
                localStorage.setItem("org_basic_data", JSON.stringify(this.org_basic_data));
                // this.org_basic_data = this.org_basic_data;
                console.log("orgdata", this.org_basic_data);
                console.log("other_form_fees_data", this.other_form_fees_data);
                let routeData = this.$router.resolve({ name: "other-fees-receipt" });
                window.open(routeData.href, "_blank");
            },
            fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //     type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                 const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
            },
            fetchOtherFeesReport() {
                const formData = {
                    ay: this.ay,
                    std: this.std_all,
                    fromdate: this.fromdate,
                    todate: this.todate,
                };
                this.pay_loader = true;
                (this.other_form_fees_data = null), (this.report_data = []);
                axios
                    .post("/MiscAndOtherFees/fetchOtherFeesReport", formData)
                    .then((res) => {
                        console.log(res.data);
                        if (res.data.flag == "YES") {
                            this.report_data = res.data.other_fees_data;
                            this.org_basic_data = res.data.org_basic_data;
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.pay_loader = false;
                    })
                    .catch((error) => {
                        this.onerror(error);
                        this.pay_loader = false;
                    })
                    .finally(() => {
                        this.pay_loader = false;
                    });
            },
            reset() {
                //this.ay= null;
                this.std = null;
                //this.mode=null;
                this.stud_name = null;
                this.dob = null;
                this.amount = 0;
                this.remark = "";
            },
            payOtherFees() {
                if (this.stud_name == null || this.amount == null) {
                    this.showSnackbar("red", "Please add mandatory fields");
                    return;
                }
                const formData = {
                    ay: this.ay,
                    std: this.std,
                    mode: this.mode,
                    name: this.stud_name,
                    dob: this.dob,
                    remark: this.remark,
                    amount: this.amount,
                };
                this.pay_loader = true;
                axios
                    .post("/MiscAndOtherFees/payOtherFees", formData)
                    .then((res) => {
                        console.log(res.data);
                        if (res.data.flag == "YES") {
                            this.showSnackbar("green", res.data.snackbar);
                            this.reset();
                            this.other_form_fees_data = res.data.other_form_data;
                            this.org_basic_data = res.data.org_basic_data;
                            this.pay_receipt_dialog = true;
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.pay_loader = false;
                    })
                    .catch((error) => {
                        this.onerror(error);
                        this.pay_loader = false;
                    })
                    .finally(() => {
                        this.pay_loader = false;
                    });
            },
            formatDate(date) {
                if (!date) return null;
                const [year, month, day] = date.split("-");
                return `${day}/${month}/${year}`;
            },
            parseDate(date) {
                if (!date) return null;
                const [month, day, year] = date.split("/");
                return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
            },
            onLoad() {
                this.overlay = true;
                axios
                    .post("/MiscAndOtherFees/getOtherFees")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.aylist = res.data.aylist;
                            this.ay = res.data.cay;
                            this.std_list = res.data.std_list;
                            this.std_list_all = res.data.std_list_all
                            this.mode_list = res.data.mode_list;
                            this.mode = this.mode_list[0].id;
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onerror(error) {
                let msg = "";
                if (error.response) {
                    msg = "Something went wrong.";
                } else if (error.request) {
                    msg = "Please try again.";
                } else {
                    msg = "Un-expected error.";
                }
                this.showSnackbar("error", msg);
            },
        },
    };
</script>

<style scoped>
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }
    @media all and (max-width: 900px) {
        .padding-bot {
            padding: 8px;
        }
    }

    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }

    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
    }
    @media print {
        header,
        footer,
        nav,
        date {
            display: none !important;
        }
        table,
        td,
        tr {
            break-inside: avoid-page;
        }
        img {
            width: 100% !important;
        }
        body,
        tr,
        th,
        td {
            font-size: x-large !important;
            font-weight: bold !important;
        }
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        @page {
            size: A4 landscape;
            margin-top: none;
            padding-top: none;
            size: 25in 15in;
        }
        table,
        td,
        tr,
        th {
            text-align: center !important;
            margin-top: none;
            padding: 0.3rem !important;
            font-size: x-large !important;
            font-weight: bold !important;
            border-bottom: 1px solid black;
            border: 1px solid black;
        }
    }
    .table-container {
        overflow-x: hidden;
        overflow: hidden;
    }
    .text {
        color: red !important;
        font-size: bold !important;
    }
</style>
